import DashboardPageTabs from "./DashboardPageTabs";

export default DashboardPageTabs;